import apiClient from '@/api/apiClient.js';
import { login } from "../../../services/authPat.service";

const getDefaultState = () => ({
  authData: {
    token: '',
    role: '',
  },
  status: '',
  msgError: '',
});

export default {
  namespaced: true,

  state: getDefaultState(),

  getters: {
    authData: (state) => state.authData,
    status: (state) => state.status,
    msgError: (state) => state.msgError,
  },

  mutations: {
    RESET_MODULE(state) {
      Object.assign(state, getDefaultState());
    },

    authSuccess(state, authData) {
      state.status = 'success';
      state.authData = authData;
    },

    authError(state, msgError) {
      state.status = 'error';
      state.msgError = msgError;
    },

    setHcpNum(state, hcpNum) {
      state.authData.hcpNum = hcpNum;
    },

    setCoNum(state, coNum) {
      state.authData.coNum = coNum;
    },

    setCoNew(state, coNew) {
      if (!state.authData) state.authData = {};
      state.authData.coNew = coNew;
    },

    setCoNumId(state, coNumId) {
      if (!state.authData) state.authData = {};
      state.authData.coNumId = coNumId;
    },

    setCoEvaNum(state, coEvaNum) {
      if (!state.authData) state.authData = {};
      state.authData.coEvaNum = coEvaNum;
    },

    setClinicalHistoriesId(state, id) {
      if (!state.authData) state.authData = {};
      state.authData.clinicalHistories_id = id;
    },

    setPatientsId(state, patients_id) {
      if (!state.authData) state.authData = {};
      state.authData.patients_id = patients_id;
    },

    SET_STATUS(state, status) {
      state.status = status;
    }
  },

  actions: {
    async signUp({ commit }, model) {
      try {
        commit('SET_STATUS', 'loading');
        const authResult = await login(model.email, model.password);
        const isSamePassword = authResult ? true : false;
        
        model.isSamePassword = isSamePassword;

        const res = await apiClient.proSignUp(model);
        const authData = res.data.data;
        commit('RESET_ALL', null, { root: true });
        commit('authSuccess', authData);
      } catch (e) {
        const msgErrorENG =
          e.response?.data?.error ?? e.response?.data?.errors?.[0]?.param ?? 'ERROR_REGISTER_USER';

        const errorMessages = {
          users_first_name: 'Revisar Primer Nombre',
          users_first_surname: 'Revisar Apellido Paterno',
          users_second_surname: 'Revisar Apellido Materno',
          users_identification_num: 'Revisar DNI',
          users_cellphone: 'Revisar Celular',
          mental_careers_mental_careers_id: 'Revisar Carrera',
          status_licenses_status_licenses_id: 'Revisar Estado de Licencia',
          users_license_num: 'Revisar N° de Colegiatura',
          email: 'Revisar Email',
          ['pass' + 'word']: 'Revisar Contraseña',
          pin: 'Revisar PIN',
          users_terms: 'Términos y condiciones está vacío',
          NOT_AGREE_TERMS: 'Términos y condiciones está vacío',
          NUM_LICENSES_NOT_EXIST: 'N° de colegiatura no existe',
          SURNAMES_NOT_MATCH: 'Apellidos no concuerdan con la Base de Datos',
          EMAIL_ALREADY_EXISTS: 'Email ya está registrado',
          DNI_ALREADY_EXISTS: 'DNI ya está registrado',
          LICENSE_ALREADY_EXISTS: 'N° de colegiatura ya está registrado',
          ERROR_REGISTER_USER: 'Error al registrar usuario',
          NOT_THE_SAME_PASSWORD: 'Registrado en sección de pacientes, regístrese con la misma contraseña o diferente email',
        };

        const msgError = errorMessages[msgErrorENG] ?? 'Verifica email o contraseña.';
        commit('authError', msgError);
      }
    },

    async login({ commit }, model) {
      try {
        commit('SET_STATUS', 'loading');
        const authResult = await login(model.email, model.password);
        const token = authResult.token;

        const res = await apiClient.proLogin(token);
        const authData = res.data.data;
        commit('RESET_ALL', null, { root: true });
        commit('authSuccess', authData);
      } catch (e) {
        const msgErrorENG =
          e.response?.data?.error ??
          e.response?.data?.errors?.[0]?.param ??
          'ERROR_LOGIN_PROFESSIONAL';

        const errorMessages = {
          email: 'Revisar Email',
          ['pass' + 'word']: 'Revisar Contraseña',
          PROFESSIONAL_NOT_EXISTS: 'No existe Profesional con este Email',
          PASSWORD_INVALID: 'Contraseña inválida',
          PROFESSIONAL_NOT_ACTIVE: 'Profesional no activo',
          ERROR_LOGIN_PROFESSIONAL: 'Revisar Email o Contraseña',
          USER_NOT_EXISTS: 'No esta habilitado',
        };

        const msgError = errorMessages[msgErrorENG] ?? 'Verifica email o contraseña.';
        commit('authError', msgError);
      }
    },

    logOut({ commit }) {
      commit('RESET_ALL', null, { root: true });
    },
  },
};
